import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const ApprovedScreenContent = () => {
  const { t: translatedText } = useTranslation('believe');
  const insets = useSafeAreaInsets();

  return (
    <View>
      <View style={styles.subtitleContainer}>
        <BodyBaseText numberOfLines={0}>
          {translatedText('application.approvedApplication.subtitle')}
        </BodyBaseText>
      </View>
      <ListItem
        primaryCopy={translatedText(
          'application.approvedApplication.fundInstantly',
        )}
        showsChevron={false}
        primaryNumberOfLines={0}
        leadingAccessory={{
          id: 'boltIcon',
          name: VXLComponentId.ICON,
          props: { iconKey: 'FLASH_ON', iconSize: 'MD' },
        }}
      />
      <View style={styles.dividerContainer}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText(
          'application.approvedApplication.spendingLimit',
        )}
        showsChevron={false}
        primaryNumberOfLines={0}
        leadingAccessory={{
          id: 'cardIcon',
          name: VXLComponentId.ICON,
          props: { iconKey: 'CARD', iconSize: 'MD' },
        }}
      />
      <View style={styles.dividerContainer}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText(
          'application.approvedApplication.moveMoney',
        )}
        showsChevron={false}
        primaryNumberOfLines={0}
        leadingAccessory={{
          id: 'clockIcon',
          name: VXLComponentId.ICON,
          props: { iconKey: 'CLOCK', iconSize: 'MD' },
        }}
      />
      <View
        style={[
          styles.disclosureContainer,
          { marginBottom: insets.bottom + theme.spacing.m },
        ]}
      >
        <BodyXSText numberOfLines={0}>
          {translatedText('application.approvedApplication.disclosure')}
        </BodyXSText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  disclosureContainer: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  dividerContainer: {
    paddingHorizontal: theme.spacing.m,
  },
  subtitleContainer: {
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
});

export default ApprovedScreenContent;
